export enum PaymentMethodCategoryEnumType {
  Fte = "fte",
  Contractor = "contractor",
}
